import { createReducer, on } from '@ngrx/store';

import { EmailTemplate } from '@shared/models';

import { rejectCandidateEmailTemplatesGet, rejectCandidateEmailTemplatesGetSuccess } from './email-templates.actions';

interface EmailTemplatesTypeState {
  ready: boolean;
  templates: EmailTemplate[];
}

const emailTemplateTypeInitialState: EmailTemplatesTypeState = {
  ready: false,
  templates: [],
};

export interface EmailTemplatesState {
  rejectCandiate: EmailTemplatesTypeState;
}

export const initialState: EmailTemplatesState = {
  rejectCandiate: emailTemplateTypeInitialState
};

const reducer = createReducer(
  initialState,
  on(rejectCandidateEmailTemplatesGet, (state) => ({
    ...state,
    rejectCandiate: emailTemplateTypeInitialState,
  })),
  on(rejectCandidateEmailTemplatesGetSuccess, (state, { emailTemplates:  templates}) => ({
    ...state,
    rejectCandiate: { ready: true, templates }
  })),
);

export function emilaTemplatesReducer(state: EmailTemplatesState, action) {
  return reducer(state, action);
}
